import React from "react";
import Select from "react-select";

const LisClearIndicator = (props) => {
    const {
        innerProps: { ref, ...restInnerProps },
        selectProps,
    } = props;

    return (
        <div
            {...restInnerProps}
            ref={ref}
            tabIndex={0}
            role="button"
            aria-label="Clear selection"
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    props.clearValue();
                    //selectProps.onMenuClose();
                }
            }}
            style={{
                padding: "8px",
                cursor: "pointer",
                display: "flex",
                margin: "4px 8px 0 0"
            }}
            className="icon cross-dark-grey clear-indicator"
        />
    );
};

export default LisClearIndicator;